import STATES from "../../../states";

class VoicemailRecordingNotification {

    [x: string]: any;
    static $inject = ['NotificationsService', '$state', 'BASE_URL', 'ContactsListService', 'Router'];
    constructor(NotificationsService, $state, baseUrl, ContactsListService, Router) {
        this.NotificationsService = NotificationsService;
        this.$state = $state;
        this.baseUrl = baseUrl;
        this.contactsListService = ContactsListService;
        this.router = Router;
    }

    dismissNotification() {
        this.NotificationsService.delete({id: this.notification.notificationId}, () => {
          this.onDelete();
          this.contactsListService.filterExtraBy({ callFinishType: 'INCOMING_CALL_VOICEMAIL'});
          this.router.navigateByUrl('/contacts');
        });
    }
}

export default {
    controller: VoicemailRecordingNotification,
    template: require('./voicemail.recording.html'),
    bindings: {
        notification: '<',
        onDelete: '&'
    }
};
